import {calculateMaxPoints as calcMaxMultipleChoiceScore} from './MultipleChoice/calculateMaxPoints'
import {calculateMaxPoints as calcMaxMultipleAnswerScore} from './MultipleAnswer/calculateMaxPoints'
import {calculateMaxPoints as calcMaxLueckentextScore} from './Lueckentext/calculateMaxPoints'
import {calculateMaxPoints as calcMaxFreitextScore} from './Freitext/calculateMaxPoints'
import {calculateMaxPoints as calcMaxClickSvgScore} from './ClickSvg/calculateMaxPoints'
import {calculateMaxPoints as calcMaxClickMatrixScore} from './ClickMatrix/calculateMaxPoints'
import {calculateMaxPoints as calcMaxDnDListSortScore} from "./DnDListSort/calculateMaxPoints"
import {calculateMaxPoints as calcMaxDnDGroupSortScore} from "./DnDGroupSort/calculateMaxPoints"
import {calculateMaxPoints as calcMaxDnD1u1ZuordnungenScore} from "./DnD1u1Zuordnungen/calculateMaxPoints"
import {calculateMaxPoints as calcMaxCTWebertest} from "./CTWebertest/calculateMaxPoints"
import {calculateMaxPoints as calcMaxFrankfurterAdaptiveTest} from "./FrankfurterAdaptiveTest/calculateMaxPoints"
import {calculateMaxPoints as calcMilitaryReactionTestValidator} from "./MilitaryReactionTest/calculateMaxPoints"
import {calculateMaxPoints as calcMaxFlexibleReactionTest} from "./FlexibleReactionTest/calculateMaxPoints"
import {calculateMaxPoints as calcMaxProfessionTypeTest} from "./ProfessionTypeTest/calculateMaxPoints"
import {calculateMaxPoints as calcMaxNurText} from "./NurText/calculateMaxPoints"


export const getMaxPointsCalculatorFor = (question) =>
{
    if(question.isMultipleChoice())     return calcMaxMultipleChoiceScore
    if(question.isMultipleAnswer())     return calcMaxMultipleAnswerScore
    if(question.isLueckentext())        return calcMaxLueckentextScore
    if(question.isFreitext())           return calcMaxFreitextScore
    if(question.isClickSvg())           return calcMaxClickSvgScore
    if(question.isClickMatrix())        return calcMaxClickMatrixScore
    if(question.isDnDListSort())        return calcMaxDnDListSortScore
    if(question.isDnDGroupSort())       return calcMaxDnDGroupSortScore
    if(question.isDnD1u1Zuordnungen())  return calcMaxDnD1u1ZuordnungenScore
    if(question.isCTWebertest())                return calcMaxCTWebertest
    if(question.isFrankfurterAdaptiveTest())    return calcMaxFrankfurterAdaptiveTest
    if(question.isMilitaryReactionTest())       return calcMilitaryReactionTestValidator
    if(question.isFlexibleReactionTest())       return calcMaxFlexibleReactionTest
    if(question.isProfessionTypeTest())         return calcMaxProfessionTypeTest
    if(question.isNurText())                    return calcMaxNurText
}